// extracted by css-extract-rspack-plugin
export default {"wrapper":"_16d3df0f"};